export const DraggerConstants = {
  UPLOAD_PRIMARY_TXT: "Click or drag file to this area to upload",
  UPLOAD_HINT: "Max file size is 6MB",
  MAX_FILE_COUNT: 1,
  DEFAULT_SHEET_STATE: "Pending",
  FILE_UPLOAD_SUCCESS_TXT: "Upload Completed!",
  DRAGGER_LABEL: "Material Picture",
  UPLOAD_ICON_ALT: "upload-icon",
};

export const FileUploadConstants = {
  DUPLICATE_WARNING: (fileName: string) =>
    `${fileName} is already uploaded. Do you want to upload it again?`,
  UPLOAD_SUCCESS: (fileName: string) => `${fileName} uploaded successfully`,
  UPLOAD_FAILED: (fileName: string) => `${fileName} upload failed`,
  DUPLICATE_TITLE: "Duplicate File",
  FILE_SIZE_WARNING: "File must be less than 6MB.",
  FILE_TYPE_WARNING_2: "Only Image type files are allowed",
  FILE_TYPE_WARNING: "Only Image files are allowed.",
  MAX_COUNT_WARNING: (maxCount: string) =>
    `You can only upload up to ${maxCount} file${Number(maxCount) > 1 ? "s" : ""}.`,
  PROGRESS_COLOR: "#87d068",
};
